import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import "./navheader.scss";
import Container from "react-bootstrap/Container";

const NavHeader = () => {
    const [isNavbarScrolled, setIsNavbarScrolled] = useState(false); // State to toggle navbar class

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.scrollY;

            // Toggle class for navbar
            if (currentScrollPos > 360) {
                setIsNavbarScrolled(true);
            } else {
                setIsNavbarScrolled(false);
            }
        };

        // Check scroll position on page load
        if (window.scrollY > 1) {
            setIsNavbarScrolled(true);
        }

        // Attach scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const toggleBodyClass = () => {
        document.body.classList.toggle("nav-open");
    };

    const closeNav = () => {
        document.body.classList.remove("nav-open");
    };

    const handleLinkClick = (e, id) => {
        e.preventDefault(); // Prevent the default behavior of adding a hash to the URL
        closeNav();

        const element = document.getElementById(id);
        if (element) {
            const offset = 20; // Adjust offset as needed
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;

            // Scroll to the target section
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    return (
        <>
            <header className={isNavbarScrolled ? "scrolled" : ""}>
                <nav
                    className={
                        isNavbarScrolled
                            ? "navbar navbar-expand-lg fixedNavbar"
                            : "navbar navbar-expand-lg"
                    }
                    aria-label="Main navigation"
                >
                    <Container fluid>
                        <Container className="d-flex align-items-center">
                            <button
                                className="navbar-toggler border-0 ms-auto"
                                type="button"
                                aria-label="Toggle navigation"
                                onClick={toggleBodyClass}
                            >
                                <div className="navMenu-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </button>
                            <div className="navbar-collapse offcanvas-collapse">
                                <ul className="navbar-nav me-auto mb-lg-0 mt-lg-0 container" id="navbar">
                                    <li className={"nav-item"}>
                                        <Link
                                            className="nav-link"
                                            onClick={(e) => handleLinkClick(e, "backToTop")}
                                            to="/#backToTop"
                                        >
                                            Home
                                        </Link>
                                    </li>
                                    <li className={"nav-item"}>
                                        <Link
                                            className="nav-link"
                                            onClick={(e) => handleLinkClick(e, "services")}
                                            to="/#services"
                                        >
                                            Services
                                        </Link>
                                    </li>
                                    <li className={"nav-item"}>
                                        <Link
                                            className="nav-link"
                                            onClick={(e) => handleLinkClick(e, "contact")}
                                            to="/#contact"
                                        >
                                            Contact
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </Container>
                    </Container>
                </nav>
            </header>
        </>
    );
};

export default NavHeader;